import React, {useCallback, useEffect} from 'react';
import b_ from 'b_';

import {
    BordomatikBox,
    CreativeBox,
    Survey,
    SurveysGoal,
    SurveySlug,
    SurveysParam
} from 'client/common/types';
import Modal from 'client/common/components/modal';
import TemplateWelcome from 'client/common/components/template-welcome';

import {useUpdateSurveyBoxContext} from 'client/common/hooks/survey';
import {useSendParamsOnce, useSendGoalOnce} from 'client/common/hooks/metrika';
import {CreativeSurveyData} from 'client/creatives/hooks/creatives';

import SettingsForm from './settings-form';

import './creative-settings.css';

const b = b_.with('creative-settings');

interface CreativeSettingsViewProps extends Partial<CreativeSurveyData> {
    slug: SurveySlug;
    survey?: Survey;
    canEdit: boolean;
    isPayed?: boolean;
}

export default function CreativeSettingsView(props: CreativeSettingsViewProps) {
    const {slug, survey, creative, canEdit, isPayed} = props;

    const updateSurveyBoxContext = useUpdateSurveyBoxContext(slug);
    const sendParams = useSendParamsOnce();
    const sendGoalOnce = useSendGoalOnce();

    const updateAndSendGoal = useCallback(
        async (box: unknown) => {
            await updateSurveyBoxContext(box);

            sendGoalOnce(SurveysGoal.FirstEditBoxContext);
        },
        [updateSurveyBoxContext, sendGoalOnce]
    );

    const box = survey?.box as CreativeBox | BordomatikBox;

    useEffect(() => {
        sendParams(SurveysParam.ConstructorSurveyType, box.name);
    }, [box, sendParams]);

    return (
        <div className={b()}>
            {survey && creative && (
                <>
                    {survey.templateWelcome && <TemplateWelcome {...survey.templateWelcome} />}
                    <SettingsForm
                        survey={survey}
                        box={box}
                        disabled={!canEdit}
                        creative={creative}
                        isPayed={isPayed}
                        updateSurveyBoxContext={updateAndSendGoal}
                    />
                </>
            )}
            <Modal />
        </div>
    );
}
